import { Link, useLocation } from "react-router-dom";
import { isMobile } from "../utils/func";

export const Footer = () => {
  const location = useLocation();
  const isFooterWhite = location.pathname === "";

  //  컬러 토큰 분리
  const bgColor = isFooterWhite ? "bg-[#FFF]" : "bg-[#121319]";
  const textColor = isFooterWhite ? "text-[#111]" : "text-[#FFF]";
  const subTextColor = isFooterWhite ? "text-[#4D4F58]" : "text-[#DDE0E6]";
  const hrColor = isFooterWhite ? "border-[#E5E7EB]" : "border-[#DDE0E6]";
  const logoSrc = isFooterWhite
    ? "/assets/images/logo/logo_black.png"
    : "/assets/images/logo/logo.png";

  const featureAnchors = [
    "settlement-history",
    "payout-service",
    "merchant-mgmt",
    "payment-system",
    "sales-network",
  ] as const;

  const featureLabels = [
    "결제/정산 내역",
    "정산 서비스",
    "가맹점 서비스",
    "결제 서비스",
    "영업대행 관리 서비스",
  ] as const;

  return (
    <footer
      className={`w-full flex flex-col items-center px-[16px] md:px-[40px] py-[40px] gap-8 ${bgColor}`}
    >
      {/* 상단 네비게이션 영역 */}
      <nav className="flex flex-col md:flex-row gap-8 md:px-0 w-full ">
        <div className="flex flex-row gap-8 justify-between md:justify-normal">
          <section className="flex flex-col gap-4 min-w-[130px]">
            <h3 className={`text-xl font-bold ${textColor}`}>기능 소개</h3>
            <ul className="flex flex-col gap-3">
              {featureLabels.map((label, index) => (
                <li key={label}>
                  <Link
                    className={`text-base ${subTextColor}`}
                    to={`/features#${featureAnchors[index]}`}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </section>

          <section className="flex flex-col gap-4 min-w-[130px] md:w-auto">
            <h3 className={`text-xl font-bold ${textColor}`}>서비스 안내</h3>
            <ul className="flex flex-col gap-3">
              {["품 소개", "도입 효과", "협력사와 사례"].map((label, index) => (
                <li key={label}>
                  <a
                    className={`text-base ${subTextColor}`}
                    href={
                      index === 0
                        ? "/solution"
                        : index === 1
                          ? "/efficiency"
                          : index === 2
                            ? "/case-studies"
                            : ""
                    }
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        </div>
        <div className="flex flex-row gap-8 justify-between md:justify-normal">
          <section className="flex flex-col gap-4 min-w-[130px]">
            <h3 className={`text-xl font-bold ${textColor}`}>서비스 신청하기</h3>
            <ul className="flex flex-col gap-3">
              {["품 도입문의", "FAQ", "고객센터"].map((label, index) => (
                <li key={label}>
                  <a
                    className={`text-base ${subTextColor}`}
                    href={
                      index === 0
                        ? "/inquiry-form?type=adoption"
                        : index === 1
                          ? "/faq"
                          : index === 2
                            ? "/help-center"
                            : ""
                    }
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </section>
          <section
            onClick={() => window.open("https://www.wiezon.com/")}
            className="flex flex-row  gap-1 min-w-[130px] md:w-auto cursor-pointer h-fit items-center"
          >
            <h3 className={`text-xl font-bold ${textColor} `}>회사소개</h3>
            <img className="w-6 h-6" src="/assets/images/icon/introductionCor_white.svg" alt="" />
          </section>
        </div>
        <hr className={`flex md:hidden w-full ${hrColor}`} />
      </nav>

      <hr className={`hidden md:flex w-full ${hrColor}`} />

      {/* 회사 정보 영역 */}
      <address className="flex flex-col gap-6 w-full not-italic md:px-0">
        <img width={79} src={logoSrc} alt="위지온 로고" />

        <div className="flex flex-col gap-8 md:flex-row justify-normal md:justify-between">
          <div className={`flex flex-col gap-8 md:gap-3 text-base ${subTextColor}`}>
            <div className="flex flex-col gap-2 md:gap-3">
              <div className="flex flex-row gap-3 md:gap-6">
                <span>주식회사 위지온</span>
                <span>|</span>
                <span>대표 정범진</span>
              </div>
              <span style={{ lineHeight: "24px" }}>
                서울특별시 구로구 디지털로 26길 123,{isMobile() ? <br /> : ""} 지플러스타워 1109호
              </span>
            </div>
            <span className="hidden md:flex">사업자번호 123-86-40537 | 대표전화 02-851-2331</span>
            <div className="flex md:hidden flex-col gap-2">
              <span>사업자번호 123-86-40537</span>
              <span> 대표전화 02-851-2331</span>
            </div>
            <span className="md:flex hidden">Copyright ⓒ 2026 Wiezon. All rights reserved.</span>
          </div>

          <div className="flex flex-row gap-3 items-center">
            <button
              className={`text-base ${subTextColor}`}
              onClick={() => {
                window.open("/terms/privacy");
              }}
            >
              서비스 이용약관
            </button>
            <span className={subTextColor}>|</span>
            <button
              className={`text-base ${subTextColor}`}
              onClick={() => {
                window.open("/terms/privacy");
              }}
            >
              개인정보 처리방침
            </button>
          </div>
        </div>
      </address>
    </footer>
  );
};
